import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { TextField, RaisedButton } from 'material-ui';
import { updateCReportProps, submitReportSugg } from '../../stores/contracting-reports/actions';
import R from 'ramda';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

const Suggestion = props => {
  const {
    updateProps,
    contractingReports,
    submitSugg,
    companyName,
  } = props;

  return (
    <div style={{ padding: '0 16px' }}>
      <div style={{ textAlign: 'left', display: 'block' }}>
        Suggest A Report
      </div>
      <div style={{ marginTop: '3%' }}>
        <TextField
          id="reportSugg"
          hintText="Enter your suggestions here..."
          multiLine
          onChange={({ target: { value } }) => updateProps({ suggestion: value })}
          underlineShow={false}
          style={{ whiteSpace: 'pre-wrap', width: '100%', border: '1px solid rgba(0, 0, 0, 0.12)', borderRadius: '3px', minHeight: '150px', padding: '5px', maxHeight: '150px', overflowY: 'scroll' }}
        />
      </div>
      <div style={{ display: 'block', textAlign: 'right' }}>
        <RaisedButton
          secondary
          label="Submit"
          style={{ marginTop: '3%' }}
          disabled={isNilOrEmpty(contractingReports.suggestion)}
          onTouchTap={() => {
            submitSugg(contractingReports.suggestion, companyName);
            updateProps({ suggestion: '' });
          }}
        />
      </div>
      {
        contractingReports.showSuggestionConfirmation ?
          <div style={{ fontWeight: 600, color: 'green' }}>
            Thanks for the suggestion!
          </div> : <span/>
      }
    </div>
  );
};

Suggestion.propTypes = {
  updateProps: PropTypes.func,
  contractingReports: PropTypes.object,
  submitSugg: PropTypes.func,
  companyName: PropTypes.string,
};

const mapDispatchToProps = dispatch => ({
  updateProps: (...args) => dispatch(updateCReportProps(...args)),
  submitSugg: (payload, companyName) => dispatch(submitReportSugg(payload, companyName)),
});

const mapStateToProps = ({ contractingReports, user }) => ({
  contractingReports: contractingReports.toJS(),
  companyName: user.getIn(['company', 'companyName']),
});

export default connect(mapStateToProps, mapDispatchToProps)(Suggestion);



// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/suggestion.jsx